var _desc, _defs, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 440,
    height: 48,
    viewBox: "0 0 440 48",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Portfolio Optimizer Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Isometric cube icon with orange top and gray sides, followed by the text \u201CPortfolio Optimizer\u201D in a warm orange gradient.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brandGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F6A623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C46A2A"
  })), /*#__PURE__*/React.createElement("style", null, "\n      .label {\n        font: 600 26px \"Inter\", \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n        dominant-baseline: central;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6,6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "18,0 36,10 18,20 0,10",
    fill: "#F6A623"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,10 18,20 18,36 0,26",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18,20 36,10 36,26 18,36",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "18,20 0,10 18,0 36,10",
    fill: "none",
    stroke: "rgba(255,255,255,0.15)",
    strokeWidth: 1
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 24,
    className: "label",
    fill: "url(#brandGrad)",
    letterSpacing: 0.3
  }, "\n    Portfolio Optimizer\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.bfcf1387bc2fd056df1b875ed23b6d34.svg";
export { ForwardRef as ReactComponent };